/* ==========================================================================
   suit-bundle.js — &Collar Range Suit bundle buy box
   Spec: suit-bundle-pdp-spec.md §4, §5, §7

   Data comes from <script data-sb-data> rendered by
   sections/suit-bundle-buybox.liquid (live variant availability from Liquid).
   Adds every piece in ONE /cart/add.js call. Bundle lines carry:
     _suit_id   (uuid, one per add)
     _suit_tier (suit | complete)
     _suit_role (jacket | pant | shirt | tie)
   The "Suit Bundle" discount Function prices the group. Jacket-only adds the
   jacket alone with no bundle properties.
   ========================================================================== */
(function () {
  'use strict';

  var SHIRT_SIZES = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
  var JACKET_SIZE_ORDER = ['38/Small', '40/Medium', '42/Large', '44/XL', '46/2XL'];
  var TIERS = ['jacket', 'suit', 'complete'];
  var TIER_CTA = { jacket: 'Add Jacket to Cart', suit: 'Add Suit to Cart', complete: 'Add Complete Suit to Cart' };
  var SWATCH = { 'pitch black': '#151515', 'midnight blue': '#1d2a44', 'stone grey': '#8d8f91' };

  function boot(root) {
    if (root.dataset.sbReady) return;
    root.dataset.sbReady = '1';

    var D;
    try { D = JSON.parse(root.querySelector('[data-sb-data]').textContent); }
    catch (e) { console.warn('[suit-bundle] bad data', e); return; }

    /* ---------- helpers ---------- */
    function $(sel) { return root.querySelector(sel); }
    function $$(sel) { return [].slice.call(root.querySelectorAll(sel)); }
    function idx(options, name) {
      var n = name.toLowerCase();
      for (var i = 0; i < options.length; i++) if (String(options[i]).toLowerCase().indexOf(n) > -1) return i;
      return -1;
    }
    function uniq(arr) { return arr.filter(function (v, i) { return arr.indexOf(v) === i; }); }
    function money(cents) {
      var whole = Math.floor(Math.round(cents) / 100);
      var rem = Math.round(cents) % 100;
      var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var amount = rem === 0 ? w : w + '.' + (rem < 10 ? '0' : '') + rem;
      var fmt = D.moneyFormat || '${{amount}}';
      return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, amount).replace(/<[^>]+>/g, '');
    }
    function uuid() {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    }
    function track(name, detail) {
      detail = detail || {};
      try { document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true })); } catch (e) {}
      if (Array.isArray(window.dataLayer)) {
        var payload = { event: name };
        for (var k in detail) payload[k] = detail[k];
        window.dataLayer.push(payload);
      }
    }
    function pantSort(a, b) {
      var pa = a.split('/').map(Number), pb = b.split('/').map(Number);
      return (pa[0] - pb[0]) || (pa[1] - pb[1]);
    }

    /* ---------- product indexes ---------- */
    var J = D.jacket;
    var jC = idx(J.options, 'color'), jF = idx(J.options, 'fit'), jS = idx(J.options, 'size');
    function jacketVariant(color, fit, size) {
      return J.variants.filter(function (v) { return v.o[jC] === color && v.o[jF] === fit && v.o[jS] === size; })[0] || null;
    }
    var COLORS = uniq(J.variants.map(function (v) { return v.o[jC]; }));
    var JFITS = uniq(J.variants.map(function (v) { return v.o[jF]; }));
    var JSIZES = uniq(J.variants.map(function (v) { return v.o[jS]; })).sort(function (a, b) {
      return JACKET_SIZE_ORDER.indexOf(a) - JACKET_SIZE_ORDER.indexOf(b);
    });

    var PANTS = D.pants; // { Athletic: {...}, Slim: {...} }
    var PFITS = Object.keys(PANTS);
    function pantIdx(p) { return { c: idx(p.options, 'color'), s: idx(p.options, 'size') }; }
    function pantVariant(fit, color, size) {
      var p = PANTS[fit]; if (!p) return null; var i = pantIdx(p);
      return p.variants.filter(function (v) { return v.o[i.c] === color && v.o[i.s] === size; })[0] || null;
    }
    function pantSizes(fit, color) {
      var p = PANTS[fit]; if (!p) return []; var i = pantIdx(p);
      return uniq(p.variants.filter(function (v) { return v.o[i.c] === color; }).map(function (v) { return v.o[i.s]; })).sort(pantSort);
    }
    function pantAnyInStock(color) {
      return PFITS.some(function (f) { return pantSizes(f, color).some(function (s) { var v = pantVariant(f, color, s); return v && v.a; }); });
    }

    var SHIRTS = D.shirts || [];
    function shirtByKey(k) { return SHIRTS.filter(function (s) { return s.key === k; })[0] || SHIRTS[0]; }
    function shirtVariant(shirt, fit, size) {
      if (!shirt) return null;
      var iS = idx(shirt.options, 'size'), iF = idx(shirt.options, 'fit'), iL = idx(shirt.options, 'sleeve');
      return shirt.variants.filter(function (v) {
        return v.o[iS] === size && (iF < 0 || v.o[iF] === fit) && (iL < 0 || v.o[iL] === shirt.sleeve);
      })[0] || null;
    }
    function shirtFits(shirt) {
      if (!shirt) return [];
      var iF = idx(shirt.options, 'fit');
      return iF < 0 ? [] : uniq(shirt.variants.map(function (v) { return v.o[iF]; }));
    }
    var TIES = D.ties || [];

    /* ---------- state ---------- */
    var params = new URLSearchParams(window.location.search);
    var startVariantId = Number(params.get('variant')) || 0;
    var startV = J.variants.filter(function (v) { return v.id === startVariantId; })[0] ||
                 J.variants.filter(function (v) { return v.a; })[0] || J.variants[0];

    var S = {
      color: startV.o[jC],
      tier: TIERS.indexOf(params.get('tier')) > -1 ? params.get('tier') : (D.defaultTier || 'suit'),
      jFit: startV.o[jF],
      jSize: null,
      pFit: null, pFitTouched: false,
      pSize: null,
      shirtKey: SHIRTS[0] ? SHIRTS[0].key : null,
      sFit: null, sFitTouched: false,
      sSize: null,
      tieId: null,
      msg: {}
    };
    S.pFit = PFITS.indexOf(S.jFit) > -1 ? S.jFit : PFITS[0];
    S.sFit = S.jFit;

    /* ---------- pricing ---------- */
    function firstPrice(list) { var v = list.filter(function (x) { return x; })[0]; return v ? v.p : 0; }
    function piecePrices() {
      var color = S.color;
      var jv = S.jSize ? jacketVariant(color, S.jFit, S.jSize) : null;
      var jp = jv ? jv.p : firstPrice(J.variants.filter(function (v) { return v.o[jC] === color; }));
      var pv = S.pSize ? pantVariant(S.pFit, color, S.pSize) : null;
      var pp = pv ? pv.p : firstPrice(PANTS[S.pFit] ? PANTS[S.pFit].variants : []);
      var sh = shirtByKey(S.shirtKey);
      var sv = S.sSize ? shirtVariant(sh, S.sFit, S.sSize) : null;
      var sp = sv ? sv.p : (sh ? firstPrice(sh.variants) : 0);
      var tie = TIES.filter(function (t) { return t.id === S.tieId; })[0] || TIES[0];
      var tp = tie ? tie.p : 0;
      return { jacket: jp, pant: pp, shirt: sp, tie: tp };
    }
    function tierMath(tier) {
      var p = piecePrices();
      if (tier === 'jacket') return { now: p.jacket, was: 0, save: 0 };
      var ala = tier === 'suit' ? p.jacket + p.pant : p.jacket + p.pant + p.shirt + p.tie;
      var now = D.prices[tier];
      var save = Math.max(0, ala - now);
      // Floor at $0 (spec §7): if components are cheaper than the tier price, charge à la carte, hide savings.
      if (save <= 0) return { now: ala, was: 0, save: 0 };
      return { now: now, was: ala, save: save };
    }

    /* ---------- tier availability ---------- */
    function tierAvailable(tier) {
      if (tier === 'jacket') return true;
      if (!pantAnyInStock(S.color)) return false;
      if (tier === 'complete') return TIES.length > 0 && SHIRTS.length > 0;
      return true;
    }
    function altColorWithPants() {
      return COLORS.filter(function (c) { return c !== S.color && pantAnyInStock(c); })[0];
    }

    /* ---------- rendering ---------- */
    function chip(label, opts) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sb-chip' + (opts.soldout ? ' is-soldout' : '') + (opts.other ? ' is-otherfit' : '') + (opts.low ? ' is-low' : '');
      b.setAttribute('aria-pressed', opts.on ? 'true' : 'false');
      if (opts.soldout) { b.setAttribute('aria-disabled', 'true'); }
      b.appendChild(document.createTextNode(label));
      if (opts.note) { var s = document.createElement('small'); s.textContent = opts.note; b.appendChild(s); }
      b.addEventListener('click', function () { if (!opts.soldout) opts.click(); });
      return b;
    }
    function fill(key, nodes) {
      var host = $('[data-sb-chips="' + key + '"]');
      if (!host) return;
      host.innerHTML = '';
      nodes.forEach(function (n) { host.appendChild(n); });
    }
    function setMsg(piece, html, isError) {
      var el = $('[data-sb-msg="' + piece + '"]');
      if (!el) return;
      if (!html) { el.hidden = true; el.innerHTML = ''; return; }
      el.hidden = false; el.innerHTML = html; el.classList.toggle('is-error', !!isError);
    }
    function stockNote(v) {
      if (!v || !v.a) return 'Sold out';
      if (v.q) return 'Only ' + v.q + ' left';
      return '';
    }

    function renderColors() {
      var host = $('[data-sb-colors]');
      host.innerHTML = '';
      COLORS.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sb-swatch';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', c === S.color ? 'true' : 'false');
        b.setAttribute('aria-label', c);
        b.title = c;
        b.style.background = SWATCH[c.toLowerCase()] || '#ccc';
        b.addEventListener('click', function () { setColor(c); });
        host.appendChild(b);
      });
      $('[data-sb-color-label]').textContent = S.color;
      var pc = $('[data-sb-pant-color]'); if (pc) pc.textContent = S.color + ' (matches jacket)';
    }

    function renderTiers() {
      TIERS.forEach(function (t) {
        var card = $('[data-sb-tier-card="' + t + '"]');
        var input = card.querySelector('input');
        var ok = tierAvailable(t);
        var m = tierMath(t);
        input.checked = S.tier === t;
        input.disabled = !ok;
        card.classList.toggle('is-selected', S.tier === t);
        card.classList.toggle('is-disabled', !ok);
        var now = $('[data-sb-tier-now="' + t + '"]'); if (now) now.textContent = money(m.now);
        var was = $('[data-sb-tier-was="' + t + '"]'); if (was) was.textContent = m.was ? money(m.was) : '';
        var save = $('[data-sb-tier-save="' + t + '"]'); if (save) save.textContent = m.save ? 'Save ' + money(m.save) : '';
        var un = $('[data-sb-tier-unavail="' + t + '"]');
        if (un) {
          if (ok) { un.hidden = true; un.textContent = ''; }
          else {
            var alt = altColorWithPants();
            un.hidden = false;
            un.textContent = 'Suit sizes sold out in ' + S.color + (alt ? ' — try ' + alt : '');
          }
        }
      });
      $('[data-sb-upsell]').hidden = !(S.tier === 'suit' && tierAvailable('complete'));
      var sold = $('[data-sb-color-soldout]');
      if (!tierAvailable('suit')) {
        var alt = altColorWithPants();
        sold.hidden = false;
        sold.textContent = 'Suit sizes sold out in ' + S.color + (alt ? ' — try ' + alt : '') + '.';
      } else { sold.hidden = true; }
    }

    function renderPrice() {
      var m = tierMath(S.tier);
      $('[data-sb-price-now]').textContent = money(m.now);
      $('[data-sb-price-was]').textContent = m.was ? money(m.was) : '';
      $('[data-sb-price-save]').textContent = m.save ? 'Save ' + money(m.save) : '';
      $('[data-sb-cta-label]').textContent = TIER_CTA[S.tier] + ' — ' + money(m.now);
      var fs = $('[data-sb-freeship]');
      fs.hidden = !(S.tier === 'jacket' && D.freeShipCents && m.now < D.freeShipCents);
    }

    function renderJacket() {
      fill('jacket-fit', JFITS.map(function (f) {
        return chip(f, { on: f === S.jFit, click: function () { setJacketFit(f); } });
      }));
      fill('jacket-size', JSIZES.map(function (s) {
        var v = jacketVariant(S.color, S.jFit, s);
        if (!v) {
          // e.g. 46/2XL only exists in Athletic: offer it, switch fit on tap.
          var other = JFITS.filter(function (f) { var ov = jacketVariant(S.color, f, s); return ov && ov.a; })[0];
          if (!other) return chip(s, { soldout: true, note: 'Sold out' });
          return chip(s, { other: true, note: other + ' only', click: function () {
            S.jSize = s; setJacketFit(other, true);
            S.msg.jacket = s + ' comes in ' + other + ' fit. Switched to ' + other + '.';
            render();
          } });
        }
        var note = stockNote(v);
        if (v.a && v.b) note = 'Backorder';
        return chip(s, { on: s === S.jSize, soldout: !v.a, low: !!v.q, note: note, click: function () {
          S.jSize = s; S.msg.jacket = ''; clearMissing('jacket'); render();
        } });
      }));
      $('[data-sb-selected="jacket-size"]').textContent = S.jSize || '';
      setMsg('jacket', S.msg.jacket);
    }

    function renderPant() {
      fill('pant-fit', PFITS.map(function (f) {
        return chip(f, { on: f === S.pFit, click: function () { S.pFitTouched = true; setPantFit(f); render(); } });
      }));
      var mine = pantSizes(S.pFit, S.color);
      var otherFit = PFITS.filter(function (f) { return f !== S.pFit; })[0];
      var theirs = otherFit ? pantSizes(otherFit, S.color).filter(function (s) {
        var v = pantVariant(otherFit, S.color, s); return mine.indexOf(s) < 0 && v && v.a;
      }) : [];
      var all = mine.concat(theirs).sort(pantSort);
      fill('pant-size', all.map(function (s) {
        if (mine.indexOf(s) < 0) {
          return chip(s, { other: true, note: otherFit, click: function () {
            S.pFitTouched = true; setPantFit(otherFit); S.pSize = s;
            S.msg.pant = 'This waist comes in ' + otherFit + ' fit. Pant fit switched to ' + otherFit + '.';
            clearMissing('pant'); render();
          } });
        }
        var v = pantVariant(S.pFit, S.color, s);
        return chip(s, { on: s === S.pSize, soldout: !v || !v.a, low: !!(v && v.q), note: stockNote(v), click: function () {
          S.pSize = s; S.msg.pant = ''; clearMissing('pant'); render();
        } });
      }));
      $('[data-sb-selected="pant-size"]').textContent = S.pSize || '';
      setMsg('pant', S.msg.pant);
    }

    function renderShirt() {
      var sh = shirtByKey(S.shirtKey);
      fill('shirt-style', SHIRTS.map(function (x) {
        return chip(x.label, { on: x.key === S.shirtKey, click: function () {
          S.shirtKey = x.key;
          if (S.sSize) { var v = shirtVariant(x, S.sFit, S.sSize); if (!v || !v.a) S.sSize = null; }
          render();
        } });
      }));
      var fits = shirtFits(sh);
      if (fits.length && fits.indexOf(S.sFit) < 0) S.sFit = fits[0];
      fill('shirt-fit', fits.map(function (f) {
        return chip(f, { on: f === S.sFit, click: function () {
          S.sFit = f; S.sFitTouched = true;
          if (S.sSize) { var v = shirtVariant(sh, f, S.sSize); if (!v || !v.a) S.sSize = null; }
          render();
        } });
      }));
      fill('shirt-size', SHIRT_SIZES.map(function (s) {
        var v = shirtVariant(sh, S.sFit, s);
        if (!v) return chip(s, { soldout: true, note: 'N/A' });
        return chip(s, { on: s === S.sSize, soldout: !v.a, low: !!v.q, note: stockNote(v), click: function () {
          S.sSize = s; clearMissing('shirt'); render();
        } });
      }));
      $('[data-sb-selected="shirt-size"]').textContent = S.sSize || '';
    }

    function renderTies() {
      var host = $('[data-sb-ties]');
      host.innerHTML = '';
      TIES.forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sb-tie';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', t.id === S.tieId ? 'true' : 'false');
        b.setAttribute('aria-label', t.title);
        if (t.image) { var img = document.createElement('img'); img.src = t.image; img.alt = ''; img.loading = 'lazy'; img.width = 80; img.height = 112; b.appendChild(img); }
        var nm = document.createElement('span'); nm.textContent = t.title; b.appendChild(nm);
        if (t.q) { var s = document.createElement('small'); s.textContent = 'Only ' + t.q + ' left'; b.appendChild(s); }
        b.addEventListener('click', function () { S.tieId = t.id; clearMissing('tie'); render(); });
        host.appendChild(b);
      });
      var sel = TIES.filter(function (t) { return t.id === S.tieId; })[0];
      $('[data-sb-selected="tie"]').textContent = sel ? sel.title : '';
    }

    function renderPieces() {
      var showPant = S.tier !== 'jacket';
      var showExtras = S.tier === 'complete';
      $('[data-sb-piece="pant"]').hidden = !showPant;
      $('[data-sb-piece="shirt"]').hidden = !showExtras;
      $('[data-sb-piece="tie"]').hidden = !showExtras;
      var jv = S.jSize ? jacketVariant(S.color, S.jFit, S.jSize) : null;
      $('[data-sb-backorder]').hidden = !(jv && jv.b);
      $('[data-sb-backorder]').textContent = S.tier === 'jacket' ? 'This size is on backorder.' : 'Ships together when back in stock.';
    }

    function render() {
      if (!tierAvailable(S.tier)) S.tier = 'jacket';
      renderColors(); renderTiers(); renderJacket();
      if (S.tier !== 'jacket') renderPant();
      if (S.tier === 'complete') { renderShirt(); renderTies(); }
      renderPieces(); renderPrice();
    }

    /* ---------- actions ---------- */
    function syncGallery() {
      // Drive the hidden native picker so theme.js swaps the gallery to the chosen colour.
      var main = document.querySelector('main-product');
      if (!main) return;
      var input = [].slice.call(main.querySelectorAll('[data-option-name="color"] input[type="radio"]'))
        .filter(function (i) { return i.value === S.color; })[0];
      if (input && !input.checked) { input.click(); return; }
      var v = J.variants.filter(function (x) { return x.o[jC] === S.color && x.m; })[0];
      if (!v) return;
      var thumb = main.querySelector('[data-product-media-thumbnail][data-media-id="' + v.m + '"]');
      if (thumb) thumb.click();
    }
    function setColor(c) {
      S.color = c;
      var jv = S.jSize ? jacketVariant(c, S.jFit, S.jSize) : null;
      if (S.jSize && (!jv || !jv.a)) { S.jSize = null; S.msg.jacket = ''; }
      var pv = S.pSize ? pantVariant(S.pFit, c, S.pSize) : null;
      if (S.pSize && (!pv || !pv.a)) { S.pSize = null; S.msg.pant = ''; }
      render();
      syncGallery();
    }
    function setJacketFit(f, silent) {
      S.jFit = f;
      var jv = S.jSize ? jacketVariant(S.color, f, S.jSize) : null;
      if (S.jSize && (!jv || !jv.a)) S.jSize = null;
      if (!S.pFitTouched && PANTS[f]) setPantFit(f);
      if (!S.sFitTouched) S.sFit = f;
      if (!silent) { S.msg.jacket = ''; render(); }
    }
    function setPantFit(f) {
      S.pFit = f;
      var pv = S.pSize ? pantVariant(f, S.color, S.pSize) : null;
      if (S.pSize && (!pv || !pv.a)) S.pSize = null;
      S.msg.pant = '';
    }
    function setTier(t, source) {
      if (!tierAvailable(t)) return;
      var changed = S.tier !== t;
      S.tier = t;
      if (t === 'complete' && !S.tieId && TIES[0]) S.tieId = TIES[0].id;
      render();
      if (changed) track('bundle_tier_select', { tier: t, source: source || 'card', color: S.color, price: tierMath(t).now / 100 });
    }
    $$('[data-sb-tier-card] input').forEach(function (input) {
      input.addEventListener('change', function () { setTier(input.value, 'card'); });
    });
    $('[data-sb-upsell]').addEventListener('click', function () { setTier('complete', 'upsell_link'); });

    /* ---------- validation + add ---------- */
    function clearMissing(piece) {
      var el = $('[data-sb-piece="' + piece + '"]');
      if (el) el.classList.remove('is-missing');
      $('[data-sb-error]').hidden = true;
    }
    function missing(piece, text) {
      var el = $('[data-sb-piece="' + piece + '"]');
      if (el) {
        el.classList.add('is-missing');
        el.querySelectorAll('.sb-chips').forEach(function (c) { c.setAttribute('data-sb-required', ''); });
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      var err = $('[data-sb-error]'); err.hidden = false; err.textContent = text;
      return null;
    }
    function buildItems() {
      var jv = S.jSize ? jacketVariant(S.color, S.jFit, S.jSize) : null;
      if (!jv || !jv.a) return missing('jacket', 'Pick your jacket size.');
      if (S.tier === 'jacket') return [{ id: jv.id, quantity: 1 }];

      var pv = S.pSize ? pantVariant(S.pFit, S.color, S.pSize) : null;
      if (!pv || !pv.a) return missing('pant', 'Pick your waist / inseam.');
      var items = [{ role: 'jacket', id: jv.id }, { role: 'pant', id: pv.id }];

      if (S.tier === 'complete') {
        var sv = S.sSize ? shirtVariant(shirtByKey(S.shirtKey), S.sFit, S.sSize) : null;
        if (!sv || !sv.a) return missing('shirt', 'Pick your shirt size.');
        var tie = TIES.filter(function (t) { return t.id === S.tieId; })[0];
        if (!tie) return missing('tie', 'Pick a tie.');
        items.push({ role: 'shirt', id: sv.id }, { role: 'tie', id: tie.id });
      }
      var bid = uuid();
      return items.map(function (it) {
        return { id: it.id, quantity: 1, properties: { _suit_id: bid, _suit_tier: S.tier, _suit_role: it.role } };
      });
    }
    function afterAdd() {
      ['cart:refresh', 'cart:updated', 'cart:build'].forEach(function (n) {
        try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {}
      });
      if (typeof window.upcartRefreshCart === 'function' && typeof window.upcartOpenCart === 'function') {
        try { window.upcartRefreshCart(); window.upcartOpenCart(); return; } catch (e) {}
      }
      window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
    }
    var cta = $('[data-sb-cta]');
    cta.addEventListener('click', function () {
      var items = buildItems();
      if (!items) return;
      var label = $('[data-sb-cta-label]');
      var was = label.textContent;
      var m = tierMath(S.tier);
      cta.disabled = true; label.textContent = 'Adding…';
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
      }).then(function () {
        track('bundle_add_to_cart', {
          tier: S.tier, color: S.color, value: m.now / 100, savings: m.save / 100,
          bundle_id: items[0].properties ? items[0].properties._suit_id : null,
          variant_ids: items.map(function (i) { return i.id; })
        });
        cta.disabled = false; label.textContent = was;
        afterAdd();
      }).catch(function (err) {
        cta.disabled = false; label.textContent = was;
        var e = $('[data-sb-error]'); e.hidden = false; e.textContent = err.message || 'Could not add to cart. Please try again.';
      });
    });

    /* ---------- preview notice ---------- */
    var isPreview = root.hasAttribute('data-design-mode') ||
      (window.Shopify && (Shopify.designMode || (Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main')));
    if (D.showPreviewNotice && isPreview) $('[data-sb-preview-note]').hidden = false;

    /* ---------- go ---------- */
    if (S.tier === 'complete' && TIES[0]) S.tieId = TIES[0].id;
    render();
    if (S.color !== startV.o[jC]) syncGallery();
    track('bundle_tier_view', { tier: S.tier, color: S.color, source: params.get('tier') ? 'url' : 'default' });
  }

  function init() { document.querySelectorAll('[data-sb-root]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-sb-root]'); if (r) boot(r);
  });
})();
